import * as Types from '../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SfmcActionFlowsQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.ActionFlowConfigsOrderBy> | Types.ActionFlowConfigsOrderBy;
}>;


export type SfmcActionFlowsQuery = { __typename?: 'Query', actionFlowConfigs?: { __typename?: 'ActionFlowConfigsConnection', nodes: Array<{ __typename?: 'ActionFlowConfig', id: string, name?: string | null, description?: string | null, configStatus?: Types.ActionFlowVersionStatus | null, currentVersion?: { __typename?: 'ActionFlowConfigVersion', nodeId: string, config: unknown, status: Types.ActionFlowVersionStatus } | null, connectorRuntimes: { __typename?: 'ConnectorRuntimesConnection', nodes: Array<{ __typename?: 'ConnectorRuntime', id: string, secret: string }> } }> } | null };

export type SfmcActionFlowFragment = { __typename?: 'ActionFlowConfig', id: string, name?: string | null, description?: string | null, configStatus?: Types.ActionFlowVersionStatus | null, currentVersion?: { __typename?: 'ActionFlowConfigVersion', nodeId: string, config: unknown, status: Types.ActionFlowVersionStatus } | null, connectorRuntimes: { __typename?: 'ConnectorRuntimesConnection', nodes: Array<{ __typename?: 'ConnectorRuntime', id: string, secret: string }> } };

export const SfmcActionFlowFragmentDoc = gql`
    fragment SfmcActionFlow on ActionFlowConfig {
  id
  name
  description
  configStatus
  currentVersion {
    nodeId
    config
    status
  }
  connectorRuntimes: connectorRuntimesByEnvironmentIdAndFlowConfigId {
    nodes {
      id
      secret
    }
  }
}
    `;
export const SfmcActionFlowsDocument = gql`
    query SfmcActionFlows($environmentId: String!, $orderBy: [ActionFlowConfigsOrderBy!]! = [CONFIG_LAST_UPDATED_DESC]) {
  actionFlowConfigs(
    condition: {environmentId: $environmentId}
    filter: {configStatus: {distinctFrom: ARCHIVED}}
    orderBy: $orderBy
  ) {
    nodes {
      ...SfmcActionFlow
    }
  }
}
    ${SfmcActionFlowFragmentDoc}`;

/**
 * __useSfmcActionFlowsQuery__
 *
 * To run a query within a React component, call `useSfmcActionFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSfmcActionFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSfmcActionFlowsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSfmcActionFlowsQuery(baseOptions: Apollo.QueryHookOptions<SfmcActionFlowsQuery, SfmcActionFlowsQueryVariables> & ({ variables: SfmcActionFlowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SfmcActionFlowsQuery, SfmcActionFlowsQueryVariables>(SfmcActionFlowsDocument, options);
      }
export function useSfmcActionFlowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SfmcActionFlowsQuery, SfmcActionFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SfmcActionFlowsQuery, SfmcActionFlowsQueryVariables>(SfmcActionFlowsDocument, options);
        }
export function useSfmcActionFlowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SfmcActionFlowsQuery, SfmcActionFlowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SfmcActionFlowsQuery, SfmcActionFlowsQueryVariables>(SfmcActionFlowsDocument, options);
        }
export type SfmcActionFlowsQueryHookResult = ReturnType<typeof useSfmcActionFlowsQuery>;
export type SfmcActionFlowsLazyQueryHookResult = ReturnType<typeof useSfmcActionFlowsLazyQuery>;
export type SfmcActionFlowsSuspenseQueryHookResult = ReturnType<typeof useSfmcActionFlowsSuspenseQuery>;
export type SfmcActionFlowsQueryResult = Apollo.QueryResult<SfmcActionFlowsQuery, SfmcActionFlowsQueryVariables>;